import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import i18n from "shared/i18n";
import { Translation } from 'react-i18next';

import {connect} from "react-redux";
import { patchProductLink } from 'redux/catalog/actions';

import onClickOutside from "react-onclickoutside";

import InputField from 'components/elements/InputField';

import './ProductItemName.css';

const ENTER_KEY = 13;


class ProductItemName extends Component {
  static propTypes = {
    patchProductLink: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    location: PropTypes.object,
    productId: PropTypes.number.isRequired,
    patchProductLinkError: PropTypes.object,
  };

  static defaultProps = {
    location: null,
    patchProductLinkError: null,
  };

  state = {
    initialValue: null,
    currentValue: null,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);

    if (this.props.name) {
      this.setState({
        initialValue: this.props.name,
        currentValue: this.props.name,
      });
    }

    if (this.props.location) {
      const isInputFocused = this.useQuery(this.props.location.search);
      if (isInputFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.name !== this.props.name) {
      this.setState({ currentValue: this.props.name });
    }

    if (prevProps.location !== this.props.location) {
      const isInputFocused = this.useQuery(this.props.location.search);
      if (isInputFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  inputEditFieldRef = createRef();

  changeProductName = () => {
    const { initialValue, currentValue } = this.state;

    if (
      currentValue !== initialValue &&
      currentValue.length > 0
    ) {
      this.setState({ initialValue: currentValue});
      const form = new FormData();
      form.append('name', currentValue);
      this.props.patchProductLink(this.props.productId, form);
    }
  };

  onEnterClick = (event) => {
    if (event.keyCode === ENTER_KEY) {
      this.changeProductName();
    }
  };

  useQuery = param => {
    return new URLSearchParams(param).get('focus');
  };

  handleClickOutside = () => {
    this.changeProductName();
  };

  executeValidation = () => {
    const { patchProductLinkError } = this.props;
    const { currentValue } = this.state;

    if (patchProductLinkError && patchProductLinkError.name) {
      return patchProductLinkError.name;
    }
    if (currentValue === '' ) {
      return i18n.t("Product Name should not be empty");
    }
    return null;
  };

  render() {
    const { currentValue } = this.state;

    return (
      <Translation>
        {(t) => (
          <div className="product-item-name__component">
            <div className="input-wrapper">
              <InputField
                value={currentValue}
                onChange={(e) => {
                  e.preventDefault();
                  this.setState({ currentValue: e.target.value });
                }}
                customRef={this.inputEditFieldRef}
                error={this.executeValidation() && {text: this.executeValidation()}}
              />
            </div>
            <div className="subtext">{t("Product Name")}</div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    patchProductLinkError: state.catalogReducer.patchProductLinkError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchProductLink,
  },
)(onClickOutside(ProductItemName));
